import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice } from '../alcance/interfaces/database';

@Injectable({
  providedIn: 'root'
})
export class AlmoxarifadoDBService extends DatabaseService {
    override classname: string = 'AlmoxarifadoDBService';
    override table = 'almoxarifado';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
    ];

    protected override migration: number = 2;
}
